/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300);
  display: block;
  width: 100%;
}

[internal-host] {
  background: var(--background);
  padding: var(--padding);
  color: var(--color);
  display: flex;
}
